import script from "./PrinterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PrinterCard.vue?vue&type=script&setup=true&lang=js"

import "./PrinterCard.vue?vue&type=style&index=0&id=3a3222cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a3222cc"]])

export default __exports__